import { NgModule } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FlexModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';
import { FuseSharedModule } from '@fuse/shared.module';
import { SharedModule } from '@shared/shared.module';
import { SignAvvComponent } from '@modules/bcm/@work-flows/sign-avv/sign-avv.component';
import { FormWidgetAvvModule } from '@modules/bcm/@work-flows/@form-widgets/core/avv/form-widget-avv.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    declarations: [SignAvvComponent],
    imports: [
        FuseSharedModule,
        SharedModule,

        DragDropModule,
        FlexModule,

        MatToolbarModule,
        MatIconModule,
        MatDialogModule,
        MatButtonModule,
        MatFormFieldModule,

        FormWidgetAvvModule,
        MatDividerModule,
        MatProgressSpinnerModule,
    ],
    exports: [SignAvvComponent]
})
export class SignAvvModule {

}
